export default "__VITE_ASSET__opX8g2L7__"